<template>
	<div>
		<AppHeader title="텐텐쿠폰 스탬프 현황" is-history />

		<AppContent>
			<AsStampIndex />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import AsStampIndex from '@/components/AsStamp/AsStampIndex';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		AsStampIndex,
	},
};
</script>
